// oxlint-disable-next-line no-restricted-imports
import useOriginalResizeObserver, { type UseResizeObserverCallback, type UseResizeObserverOptions } from '@react-hook/resize-observer'
// oxlint-disable-next-line no-restricted-imports
export { type UseResizeObserverCallback } from '@react-hook/resize-observer'

class ServerSideResizeObserverPolyfill {
  // oxlint-disable-next-line no-useless-constructor
  constructor(_callback: ResizeObserverCallback) {}
  observe(_target: Element, _options?: ResizeObserverOptions) {}
  unobserve(_target: Element) {}
}

const DEFAULT_OPTIONS: UseResizeObserverOptions = {
  polyfill: typeof window === 'undefined' ? ServerSideResizeObserverPolyfill : null,
}

/**
 * A React hook that fires a callback whenever ResizeObserver detects a change to its size
 */
function useResizeObserver<T extends Element>(
  /** A React ref created by `useRef()` or an HTML element */
  target: React.RefObject<T> | React.ForwardedRef<T> | T | null,
  /** Invoked with a single `ResizeObserverEntry` any time the `target` resizes */
  callback: UseResizeObserverCallback,
) {
  return useOriginalResizeObserver(target, callback, DEFAULT_OPTIONS)
}

export default useResizeObserver
